module.exports = __webpack_public_path__ + "img/hero-1-alternative-guide.5ccb39d1.png";